import s from './style.css';
import cn from 'classnames';
import LineWrapper from 'components/LineWrapper';
import calcPercentage from 'utils/calcAreaPercentage';

const getFill = (fill, secondHalfFill, oddFill, i, j, max) => {
	if (secondHalfFill && i >= max / 2) {
		return secondHalfFill;
	}

	if (oddFill && j % 2) {
		return oddFill;
	}

	return fill;
};

const RadialChart = ({
	data = [],
	max = 100,
	includePercentage,
	fill = '#82DEBC',
	secondHalfFill,
	oddFill,
	keys,
	inView,
	degNum,
	topTight
}) => (
	<LineWrapper className={s.container} topTight={topTight}>
		<div className={cn(s.container, { [s.hidden]: !inView })}>
			<div className={s.wrapper}>
				{(keys || [max]).map(num => (
					<div
						className={s.key}
						style={{
							width: `${calcPercentage(num, max)}%`,
							height: `${calcPercentage(num, max)}%`,
							transform: `translate(-50%, -50%) scale(1) rotate(${degNum}deg)`
						}}
					>
						<div className={s.keyInner}>{num}%</div>
					</div>
				))}
				<div>
					{data.map(({ fact, description, percentage }, i) => (
						<div className={s.section}>
							<div
								className={s.sliceWrap}
								style={{
									transitionDelay: `${0.2 + 0.1 * i}s`
								}}
							>
								{percentage.split(',').map((num, j) => (
									<svg
										className={s.slice}
										viewBox="0 0 100 100"
										style={{
											transform: `scale(${calcPercentage(+num, max) /
												100}) rotate(${(i / data.length) *
												360}deg) rotate(${(60 / percentage.split(',').length) *
												j}deg)`
										}}
									>
										<path
											d={`M50,50 L50,0 L${50 +
												Math.tan(
													((60 / percentage.split(',').length) * Math.PI) / 180
												) *
													50},0`}
											clip-path={`url(#circle)`}
											fill={getFill(
												fill,
												secondHalfFill,
												oddFill,
												i,
												j,
												data.length
											)}
										/>
									</svg>
								))}
							</div>

							<p
								className={s.text}
								style={{
									transitionDelay: `${0.4 + 0.1 * i}s`
								}}
							>
								<span className={s.textInner}>
									{includePercentage && <p>{percentage}%</p>}
									{fact}
									{description && (
										<p className={s.textDescriptionInner}>{description}</p>
									)}
								</span>
							</p>
						</div>
					))}
				</div>
			</div>
		</div>
	</LineWrapper>
);

export default RadialChart;



// WEBPACK FOOTER //
// ./components/RadialChart/index.js